import { Bubble, Props } from './Bubble';

export const InputTextBubble = (props: Props) => (
  <>
    <Bubble {...props}>
      <div className="rounded-2xl border bg-white px-4 py-3 drop-shadow-sm">
        <p className="whitespace-pre-line">{props.message.text}</p>
      </div>
    </Bubble>
    {props.isWaiting && <div className="h-16"></div>}
  </>
);
